import React from 'react'
import { Box, Button, Flex, Heading, Link, Text } from '@workwhile/ui'
import { Phone, RotateCcw } from 'lucide-react'
import { Header } from 'components/Header'
import * as ROUTES from 'constants/routes'
import { useVoiceAgentCallContextValue } from '../context/VoiceAgentCallContext'
import { CallControls } from './CallControls'
import { Transcript } from './Transcript'
import { CallStatus } from './CallStatus'

type VoiceAgentCallMainProps = {
  detailsContent?: React.ReactNode
  secondaryContent?: React.ReactNode
}

export const VoiceAgentCallMain = ({
  detailsContent,
  secondaryContent,
}: VoiceAgentCallMainProps) => {
  const {
    state: { title, callState },
    actions: { startCall, reset },
  } = useVoiceAgentCallContextValue()

  return (
    <>
      <Header
        title={
          <Flex alignItems="flex-start" gap={2} flexDirection="column">
            <Text
              as={Link}
              color="lightText"
              style={{
                textTransform: 'uppercase',
              }}
              to={ROUTES.PLAYGROUND}
              fontSize={0}
            >
              Playground
            </Text>
            <Heading level={1} style={{ margin: 0 }} fontWeight="400">
              {title}
            </Heading>
          </Flex>
        }
        rightContent={
          <Flex alignItems="center" gap={2}>
            <CallStatus />
            {callState === 'idle' && (
              <Button variant="primary" kind="medium" onClick={startCall}>
                <Flex alignItems="center" gap={1}>
                  <Phone size={14} />
                  Start Call
                </Flex>
              </Button>
            )}
            {callState === 'error' && (
              <Button variant="primary" kind="medium" onClick={reset}>
                <Flex alignItems="center" gap={1}>
                  <RotateCcw size={14} />
                  Try Again
                </Flex>
              </Button>
            )}
            {callState === 'ended' && (
              <Button variant="primary" kind="medium" onClick={reset}>
                <Flex alignItems="center" gap={1}>
                  <Phone size={14} />
                  New Call
                </Flex>
              </Button>
            )}
            {callState === 'active' && <CallControls />}
          </Flex>
        }
      />
      <Box margin={3}>
        <Flex gap={3} wrap="wrap" marginTop={3}>
          {detailsContent}
          <Transcript />
        </Flex>
        {secondaryContent ? (
          <Flex gap={3} wrap="wrap" marginTop={3}>
            {secondaryContent}
          </Flex>
        ) : null}
      </Box>
    </>
  )
}
